<template>
  <div>
    <v-form @submit.prevent="submit">
      <v-select
          id="font-size"
          v-model="zoomScale"
          :items="items"
          :label="$t('font_size')"
          @change="submit"></v-select>
      <p class="v-label v-label--active theme--light">{{ $t('device_type') }}:</p>
      <v-btn-toggle
          class="d-flex flex-column flex-sm-row"
          v-model="device"
          id="device-type"
          tile
          group
          mandatory
          @change="submit"
      >
        <v-btn id="default-device" value="zebra">
          {{ $t('inbuilt_scanner') }}
        </v-btn>
        <v-btn id="glove-device" value="glove_scanner">
          {{ $t('glove_scanner') }}
        </v-btn>
      </v-btn-toggle>
    </v-form>
  </div>
</template>

<script>
import { bus } from '@/bootstrap/bus'
import { ZoomLevels } from "@/enums/ZoomLevels"

export default {
  name: "Settings",
  data() {
    return {
      device: "zebra",
      zoomScale: ZoomLevels.STANDARD,
      items: [
        {
          text: this.$t('standard'),
          value: ZoomLevels.STANDARD,
        },
        {
          text: this.$t('large'),
          value: ZoomLevels.LARGE,
        },
        {
          text: this.$t('extra_large'),
          value: ZoomLevels.EXTRA_LARGE,
        }
      ]
    }
  },
  methods: {
    submit() {
      bus.$emit('zoomChanged', this.zoomScale);
      this.$cookies.set('device', this.device);
    }
  },
  created() {
    if (this.$cookies) {
      this.zoomScale = Number(this.$cookies.get('zoom')) ? parseFloat(this.$cookies.get('zoom')) : ZoomLevels.STANDARD
      this.device = this.$cookies.get('device');
    }
  }
}
</script>
